import BetaBadge from 'components/BetaBadge';
import SubMenu, { SubMenuTitle } from 'components/SubMenu';
import Routes from 'constants/Routes';
import { Outlet } from 'react-router-dom';
import { arraySpreadIf } from 'utils/spreading';
import useHasAccessToDayPlanning from 'hooks/useHasAccessToDayPlanning';
import useRoutePlanFeedbackAccess from 'hooks/useRoutePlanFeedbackAccess';

const TransportLogisticsPage = () => {
  const hasAccessToDayPlanning = useHasAccessToDayPlanning();
  // Kvällens ruttprov: trafikledare (har planerat uppdrag), skrivlistan 106 och namnläsarna.
  const { canGiveFeedback } = useRoutePlanFeedbackAccess();

  const menuItems = [
    ...arraySpreadIf(hasAccessToDayPlanning, {
      label: <SubMenuTitle>Dagsplanering</SubMenuTitle>,
      path: Routes.transportLogistics.dayPlanning,
    }),
    {
      label: <SubMenuTitle>Uppföljning</SubMenuTitle>,
      path: Routes.transportLogistics.followUp,
    },
    // Syns för alla. Tidigare dold bakom en egen användarlista (GlobalSetting 93, pensionerad);
    // nu talar BETA-märkningen om att den fortfarande förändras. Vem som får VERKSTÄLLA styrs
    // fortfarande av en lista — se useHasAccessToRoutePlanApply.
    {
      label: (
        <SubMenuTitle>
          Ruttplanering{' '}
          <BetaBadge title="Ruttplaneringen är en BETA-funktion och förändras fortfarande" />
        </SubMenuTitle>
      ),
      path: Routes.transportLogistics.routePlanning,
    },
    ...arraySpreadIf(canGiveFeedback, {
      label: <SubMenuTitle>Ruttfeedback</SubMenuTitle>,
      path: Routes.transportLogistics.routePlanFeedback,
    }),
  ];

  return (
    <>
      {menuItems.length > 1 && <SubMenu items={menuItems} />}
      <Outlet />
    </>
  );
};

export default TransportLogisticsPage;
